import React from "react";
import { motion } from "framer-motion";
import {
  ShieldCheck, ScrollText, Cloud, Lock, Network, Server, Database, BadgeCheck, Wrench
} from "lucide-react";

const ICONS = {
  "shield-check": ShieldCheck,
  "scroll-text": ScrollText,
  cloud: Cloud,
  lock: Lock,
  network: Network,
  server: Server,
  database: Database,
  "badge-check": BadgeCheck,
  wrench: Wrench
};

const Skills = ({ skills }) => {
  if (!skills?.length) return null;

  return (
    <section id="arsenal" className="py-24 md:py-32 border-t border-white/10" data-testid="skills-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <p className="font-mono text-xs tracking-[0.3em] text-emerald-400 mb-4">THE ARSENAL</p>
        <h2 className="font-display text-3xl md:text-4xl text-gray-100 mb-16">
          Nine disciplines, <span className="italic text-emerald-400">one structure.</span>
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {skills.map((cat, i) => {
            const Icon = ICONS[cat.icon] || ShieldCheck;
            return (
              <motion.div
                key={cat.category}
                className="group bg-[#0a0a0a] p-8 hover:bg-[#0d0d0d] transition-colors"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ delay: (i % 3) * 0.08 }}
                viewport={{ once: true }}
                data-testid={`skill-category-${i}`}
              >
                <Icon className="h-5 w-5 text-emerald-400 mb-5" />
                <h3 className="font-mono text-sm tracking-widest uppercase text-gray-100 mb-5">{cat.category}</h3>
                <div className="flex flex-wrap gap-2">
                  {cat.items.map((item) => (
                    <span
                      key={item}
                      className="font-mono text-[11px] text-gray-400 border border-white/10 px-2 py-1 group-hover:border-white/20 transition-colors"
                    >
                      {item}
                    </span>
                  ))}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Skills;
